import ngCookies from 'angular-cookies';
import memoize from 'lodash/memoize';

export const StorageServiceModule = angular
    .module('app.services.storage.storageService', [
        ngCookies
    ]).factory('storageService', ($window, $cookies) => {
        return {
            supported: memoize(supported),
            updateCookieObject,
            getCookieObject
        };

        function supported() {
            const testKey = 'test';
            let storage = $window.localStorage;
            try {
                storage.setItem(testKey, '1');
                storage.removeItem(testKey);
                return true;
            } catch (error) {
                return false;
            }
        }

        function updateCookieObject(cookieName, object, options) {
            let existingCookie = $cookies.getObject(cookieName);
            let objectToPut = angular.isDefined(existingCookie) ? existingCookie : {};
            angular.extend(objectToPut, object);
            $cookies.putObject(cookieName, objectToPut, options);
        }

        function getCookieObject(cookieName, keyName) {
            let object = $cookies.getObject(cookieName);
            return object ? object[keyName] : undefined;
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/storage/storage.service.js